/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Skip_To_ContentInputs */

const en_common_skip_to_content = /** @type {(inputs: Common_Skip_To_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const zh_common_skip_to_content = /** @type {(inputs: Common_Skip_To_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳到内容`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Common_Skip_To_ContentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_skip_to_content = /** @type {((inputs?: Common_Skip_To_ContentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Skip_To_ContentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_skip_to_content(inputs)
	return zh_common_skip_to_content(inputs)
});
export { common_skip_to_content as "common.skip_to_content" }